<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Unificación de CURP</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'RENAPO' }, { label: 'Unificación de CURP' }]" />
    </div>
  </section>

  <section wrapper>
    <p-tabView [activeIndex]="1">
      <p-tabPanel tabindex="1" header="Subir archivo" *showForRoles="['GESTOR']">
        <app-upload />
      </p-tabPanel>
    </p-tabView>
  </section>
</backbone>
